/* global BMapGL BMapGLLib */
import { ExtendedLuShu } from './extendedLuShu';
import MapBase from './mapBase';
import { drivingRouteConfig, startAndEndIconConfig, polylineConfig } from './mapConfig';
class WaybillMap extends MapBase {
    // 初始化地图
    initMap (options = {}) {
        this.options = options;
        this.map.clearOverlays();
        this.dealWithMapLogic(options);
        this.setViewport();
    }
    // 处理地图逻辑
    dealWithMapLogic(options) {
        // 添加起始点终点标注
        this.addStartEndMarker(options.drivingRoutePoint);
        // 添加车辆当前定位标注
        this.addCarPostionMarker(options.currentPosition, options.isShowCarIcon);
        // 绘制车辆定位线路图
        this.drivingCarPositionLine(options.polylinePoint, options.isShowTakeOrderPoint);
    }
    /**
     * @description 添加起点终点标注
     * @param {Array} drivingRoutePoint 起点终点经纬度
     */
    addStartEndMarker (drivingRoutePoint) {
        if (drivingRoutePoint.length === 4) {
            const start = this.toAxisPoint(drivingRoutePoint[0], drivingRoutePoint[1]);
            const end = this.toAxisPoint(drivingRoutePoint[2], drivingRoutePoint[3]);
            this.addIconMarker(start, startAndEndIconConfig.startIcon);
            this.addIconMarker(end, startAndEndIconConfig.endIcon);
        }
        // this.setDrivingRouteColor(driving); // 设置路线颜色
    }
    // 移除原有标注
    removeOriginMarker(routes) {
        for (let i = 0; i < routes.length; i++) {
            if (i === 0 || i === routes.length - 1) {
                this.map.removeOverlay(routes[i].marker);
            }
        }
    }
    // 设置路线颜色
    setDrivingRouteColor(driving) {
        driving.setSearchCompleteCallback(() => {
            const plan = driving.getResults().getPlan(0);
            for (let i = 0; i < plan.getNumRoutes(); i++) {
                const pts = plan.getRoute(i).getPath();
                const polyline = new BMapGL.Polyline(pts, drivingRouteConfig);
                this.map.addOverlay(polyline);
            }
        });
    }
    /**
     * @description 添加车辆定位标注
     * @param {Object} carPositionInfo 车辆当前定位信息
     * @param {Boolean} isShowCarIcon 是否显示车辆图标
     */
    addCarPostionMarker (carPositionInfo, isShowCarIcon) {
        if (isShowCarIcon) {
            if (carPositionInfo.longitude && carPositionInfo.latitude) {
                const point = this.toAxisPoint(carPositionInfo.longitude, carPositionInfo.latitude);
                this.addIconMarker(point, polylineConfig.carIconPath, 50, 40, this.setSize(20, -20));
            }
        }
    }
    /**
     * @description 绘制当前车辆定位线路图
     * @param {Array} pointList 当前车辆打点集合
     * @param {Boolean} isShowTakeOrderPoint 是否显示接单点
     */
    drivingCarPositionLine (pointList, isShowTakeOrderPoint) {
        if (pointList.length > 0) {
            // 用于存储绘制轨迹的坐标点
            const positionPointList = [];
            // 用于存储处理接单点、收货点、始发点以外的坐标点
            this.markerPointList = JSON.parse(JSON.stringify(pointList));
            for (const pointItem of pointList) {
                positionPointList.push(this.toAxisPoint(pointItem.longitude, pointItem.latitude));
            }
            // 确定起点坐标, displayType === 0 为起点
            const startPointIndex = pointList.findIndex(item => item.displayType === 0);
            // 有起点标识，才标注起点和终点
            if (startPointIndex !== -1) {
                // 添加始发地icon标注
                this.createCarRouteMarker(positionPointList[startPointIndex], startAndEndIconConfig.startSendingIcon, 32, 32, pointList[startPointIndex]);
                // 添加目的地icon标注
                this.createCarRouteMarker(positionPointList[positionPointList.length - 1], startAndEndIconConfig.endReceivingIcon, 32, 32, pointList[positionPointList.length - 1]);
                if (this.markerPointList.length >= 2) {
                    this.markerPointList.splice(startPointIndex, 1);
                    this.markerPointList.splice(this.markerPointList.length - 1, 1);
                }
            }
            if (isShowTakeOrderPoint) {
                // 添加接单点icon标注
                this.createCarRouteMarker(positionPointList[0], startAndEndIconConfig.takeOrderIcon, 24, 36, pointList[0]);
                // 防止接单点和起点为同一个点时，重复删除
                if (startPointIndex !== 0 && this.markerPointList.length >= 1) {
                    this.markerPointList.splice(0, 1);
                }
            }
            // 将待标注点经纬度转为坐标点
            const markers = this.markerPointList.map(item => this.toAxisPoint(item.longitude, item.latitude));
            // 轨迹中间点添加标注和信息窗体
            markers.forEach((item, index) => {
                this.createCarRouteMarker(item, startAndEndIconConfig.trackMarkerIcon, 6, 6, this.markerPointList[index]);
            });
            const polyline = new BMapGL.Polyline(positionPointList, polylineConfig);
            this.map.addOverlay(polyline);
            this.polylinePath = polyline.getPath();
            this.initLuShu(this.map, this.polylinePath);
        } else {
            this.initLuShu(this.map, []);
        }
    }

    // 设置地图最佳视角
    setViewport () {
        const overlays = this.map.getOverlays();
        const points = overlays.flatMap(overflow => {
            if (Array.isArray(overflow.points)) {
                return overflow.points.map(p => p.latLng);
            }
            return [overflow.latLng];
        });
        this.map.setViewport(points);
    }
    // 创建路书实例
    initLuShu (map, arrPois) {
        if (this.lushu) {
            this.lushu.clear();
        }
        if (arrPois.length === 0) {
            return;
        }
        const lushu = new BMapGLLib.LuShu(map, arrPois, {
            geodesic: true,
            autoView: true, // 自动调整视野
            icon: new BMapGL.Icon(require('../images/overLookingCar.png'), new BMapGL.Size(48, 48), { anchor: new BMapGL.Size(24, 24) }),
            defaultContent: '',
            speed: 10000,
            enableRotation: true // marker随着道路的走向进行旋转
        });

        this.lushu = new ExtendedLuShu({
            map: this.map,
            lushu
        });
    }
    start () {
        if (this.lushu) {
            this.lushu.start();
        }
    }
    pause () {
        if (this.lushu) {
            this.lushu.pause();
        }
    }
    setSpeed (n) {
        if (this.lushu) {
            this.lushu.setSpeed(10000 * n);
        }
    }
    onMove (fn) {
        if (this.lushu) {
            this.lushu.on('move', (moveParams) => {
                fn(moveParams);
            });
        }
    }
}

export default WaybillMap;
